export default "__VITE_ASSET__Bzt39Clj__"